var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgToolFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6154 14.7553H22.6564C21.4215 14.7553 20.3159 14.0629 19.7703 12.9667L19.2821 11.9858C18.3631 10.1395 16.5251 9 14.4718 9H11.3846C8.41231 9 6 11.4233 6 14.4091V27.3909C6 30.3767 8.41231 32.8 11.3846 32.8H28.6154C31.5877 32.8 34 30.3767 34 27.3909V20.1788C34 17.193 31.5877 14.7697 28.6154 14.7697V14.7553ZM31.8462 27.3765C31.8462 29.1651 30.3959 30.6219 28.6154 30.6219H11.3846C9.6041 30.6219 8.15385 29.1651 8.15385 27.3765V14.3947C8.15385 12.6061 9.6041 11.1492 11.3846 11.1492H14.4718C15.7067 11.1492 16.8123 11.8416 17.3579 12.9378L17.8462 13.9187C18.7651 15.765 20.6031 16.9045 22.6564 16.9045H28.6154C30.3959 16.9045 31.8462 18.3613 31.8462 20.1499V27.3621V27.3765Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolFolder);
export default __webpack_public_path__ + "static/media/toolFolder.feef3392.svg";
export { ForwardRef as ReactComponent };